import { deleteCookie } from "cookies-next";
import { signOut } from "next-auth/react";

export const handleSignOut = (push, dispatchCart, dispatchCheckout) => {
  deleteCookie("quote");
  deleteCookie("mage");
  dispatchCart({ type: "clear" });
  dispatchCheckout({ type: "clear" });
  signOut({ redirect: false });
  push("/");
};
